import React from 'react'
import Spinner from './Spinner'

const Loader = ({ className }) => {
  return (
    <div
      data-cy="loader"
      className={`${className} z-30 flex justify-center items-center fixed inset-0 lg:max-w-lg`}
    >
      <Spinner />
    </div>
  )
}

export default Loader
